<template>
    <b-modal v-model="isModalOpen" hide-footer
             title="Empfänger der Benachrichtigung" @hide="reset()">
        <div class="record-note-recipients-modal loading-content-container">
            <div v-if="noteRecipientsLoading > 0" class="loading-overlay d-flex justify-content-center pt-5">
                <csp-loading-indicator/>
            </div>

            <b-alert v-if="noteRecipientsLoading === 0 && noteRecipientsForTable.length === 0"
                     show variant="info">
                Keine Empfänger vorhanden
            </b-alert>

            <b-table v-if="noteRecipientsLoading === 0 && noteRecipientsForTable.length > 0"
                     :fields="recipientTableFields" :items="noteRecipientsForTable" :responsive="true"
                     striped>
                <template v-slot:table-colgroup="scope">
                    <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width ?? 'auto' }">
                </template>
            </b-table>
        </div>
    </b-modal>
</template>

<script>
import Container from '@services/Container';

const container = Container.getInstance();
const recordRepository = container.getDesktopRecordRepository();

export default {
    name: 'RecipientListModal',
    props: {
        recordId: {
            type: Number,
            required: true,
        },
        noteId: {
            type: Number,
            default: null,
        },
        hideForGroupOptions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            recipientTableFields: [
                {
                    key: 'name',
                    label: 'Name',
                    width: '300px',
                },
                {
                    key: 'email',
                    label: 'Zusätzlich per E-Mail benachrichtigt',
                },
            ],
            noteRecipients: [],
            isModalOpen: true,
            noteRecipientsLoading: 0,
        }
    },
    computed: {
        noteRecipientsForTable() {
            const recipientsForTable = [];

            this.noteRecipients.forEach((data) => {
                recipientsForTable.push({
                    recipientId: data.id,
                    ...data.attributes,
                });
            });
            return recipientsForTable;
        },
    },
    created() {
        this.loadNoteRecipients();
    },
    methods: {
        loadNoteRecipients() {
            this.noteRecipientsLoading++;
            recordRepository.getNoteRecipients(this.recordId, this.noteId)
                .then(response => {
                    this.noteRecipients = response.data;
                })
                .finally(() => {
                    this.noteRecipientsLoading--;
                });
        },
        reset() {
            this.$emit('reset');
        },
    },
}
</script>
